import { render, staticRenderFns } from "./NewsPage.vue?vue&type=template&id=2bfd14d6&scoped=true"
import script from "@/assets/js/news.js?vue&type=script&lang=js&external"
export * from "@/assets/js/news.js?vue&type=script&lang=js&external"
import style0 from "@/assets/css/news.css?vue&type=style&index=0&id=2bfd14d6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd14d6",
  null
  
)

export default component.exports